<ion-header>
  <ion-toolbar class="thin-toolbar background-background" mode="ios">
    <frontend-header routeId="floorplan">
      <div *ngIf="this.floorPlanEnabled" class="d-flex">
        <ion-segment [id]="currentPageTab + '-seg'" mode="ios" [value]="currentPageTab" (ionChange)="switchPageTab($event.detail.value)">
          <ion-segment-button [value]="pageTabs.floorplan">
            <tr-icon [icon]="icon.floorPlan"></tr-icon>
          </ion-segment-button>
          <ion-segment-button [value]="pageTabs.grid">
            <tr-icon [icon]="icon.grid"></tr-icon>
          </ion-segment-button>
        </ion-segment>
      </div>
    </frontend-header>
  </ion-toolbar>
</ion-header>

<ion-content [forceOverscroll]="false">
  <ng-container *ngIf="currentPageTab === pageTabs.floorplan && floorPlanEnabled; else dayGridView">
    <tablesready-floorplan-view
      [resources]="resources"
      [autoRemoveTime]="location.autoRemove"
      [customerPlural]="location?.displayOptions.labels.customer_plural"
      [reservationPluralLabel]="location?.displayOptions.labels.reservation_plural"
      [locationTimezone]="location?.timezone"
      [smsNextMessage]="location?.messages?.smsNext?.message"
      [notificationTime]="location?.displayOptions?.notificationTime"
      [voicePageNotificationEnabled]="user.location.messages.voicePageNotification.enabled"
      [reservationDateFilter]="dateFilter"
      [locationCountry]="location?.country"
      (dateChanged)="dateFilter = $event"
      [isOnBusinessPlan]="isLocationOnBusinessPlan"
      [plansAlertData]="plansAlertData"
      [trialCompleted]="trialCompleted"
      (partyEdit)="editParty($event)"
      (partyDelete)="confirmDelete($event)"
      (partyServed)="serve($event)"
      (partyComplete)="complete($event)"
      (partyCheckIn)="checkIn($event)"
      (partyAddWithResourceId)="addParty(floorPlanEnabled && currentPageTab === pageTabs.floorplan, $event.serveNow, $event.serveNow, $event)"
      (partyCheckInAndServe)="checkInAndServe($event)"
      (partyChat)="partyChat($event)"
      (tablesCount)="tablesCount = $event"
      (floorPlanIdSelected)="selectedFloorPlanId = $event"
      (tabChange)="$event?.title ? currentTab = $event.title : null"
      (floorPlansLoaded)="floorplanResources = $event"
    ></tablesready-floorplan-view>
  </ng-container>

  <ng-template #dayGridView>
    <ng-container *ngIf="servicesAndResourcesEnabled; else servicesAndResourcesNotEnabled">
      <tablesready-day-grid-view
        [user]="user"
        [minDate]="minDate"
        [getResourceName]="getResourceName"
        [reservationGridDateFilter]="dateFilter"
        [isOnFreePlan]="!isLocationOnBusinessPlan"
        (partyEdit)="editParty($event)"
        (partyDelete)="confirmDelete($event)"
        (partyChat)="partyChat($event)"
        (partyCheckIn)="checkIn($event)"
        (partyComplete)="complete($event)"
        (partyServed)="serve($event)"
        (createNewParty)="addReservationViaTimeline($event)"
        (chooseDate)="dateFilter = $event"
      ></tablesready-day-grid-view>
    </ng-container>
  </ng-template>

  <ng-template #servicesAndResourcesNotEnabled>
    <div class="d-flex flex-row align-items-center justify-content-center pt-4 px-3">
      <h1>You must have <a routerLink="/settings/preferences/services">services</a>, <a routerLink="/settings/preferences/resources">resources</a> enabled, and at least 1 active service and resource.</h1>
    </div>
  </ng-template>

  <div class="add-new">
      <span class="add-new-blocker" slot="fixed">
        <button type="button"
                class="btn btn-accent btn-circle user-select-none"
                (click)="addParty(floorPlanEnabled && currentPageTab === pageTabs.floorplan, currentTab !== floorPlanPartyTab.booked, currentTab === floorPlanPartyTab.serving)"
                [disabled]="!servicesAndResourcesEnabled || (isNotOnBusinessPlan && floorPlanEnabled && currentPageTab === pageTabs.floorplan)"
                [ngClass]="{'disabled' : !user || !service.schedule?.length}"
                id="addEditParty-button">
          <tr-icon [icon]="icon.plus" [size]="size.extraLarge" [color]="color.white"></tr-icon>
        </button>
      </span>
  </div>
</ion-content>
